import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {EXAMINATION_ACTION_TYPE} from "types/enums/examination";

type State = {
  actionType: EXAMINATION_ACTION_TYPE;
  dataPassing: any;
  idPKNT: string;
  examinationId: string;
  buttonHeaderExam: any[];
  dataPhieu: any;
};

const initialState: State = {
  actionType: EXAMINATION_ACTION_TYPE.NORMAL,
  dataPassing: null,
  idPKNT: null,
  examinationId: null,
};

export const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setExaminationId: (state = initialState, action: PayloadAction<any>) => {
      return {...state, examinationId: action.payload};
    },
    setActionType: (state = initialState, action: PayloadAction<any>) => {
      return {...state, actionType: action.payload};
    },
    setDataPassing: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataPassing: action.payload};
    },
    setInpatient: (state = initialState, action: PayloadAction<any>) => {
        return {
            ...state,
            ...action.payload
        };
    },
  },
});

export const {
  setActionType,
  setDataPassing,
  setExaminationId,
  setInpatient
} = commonSlice.actions;

export default commonSlice.reducer;
